module.exports = __webpack_public_path__ + "static/media/audio-chet-baker-1953.50602f49.mp3";